<template>
  <Layout>
    <SloLoader :loading="loading" size="xl">
      <SubscriptionDetails
        :subscription="subscription"
        @subscriptionUpdated="getSubscription"
      />
    </SloLoader>
  </Layout>
</template>

<script>
import t from '../../main/i18n';
import {marketplaceApi} from '../apis/marketplace';
import {handleApiErrors} from '../../main/utils';
import Layout from '../components/Layout.vue';
import SubscriptionDetails from '../components/SubscriptionDetails.vue';
import SloLoader from '../../../lib/components/SloLoader.vue';

export default {
  components: {
    Layout,
    SubscriptionDetails,
    SloLoader
  },
  data() {
    return {
      loading: true,
      subscription: null,
      subscriptionId: null
    };
  },
  async created() {
    this.subscriptionId = this.$route.params.subscriptionId;
    if (!this.subscriptionId) {
      this.$snotify.error(t('Insufficient subscription information provided'));
      await this.$router.push({name: 'marketplace-account-subscriptions'});
      return;
    }

    await this.getSubscription();
  },
  methods: {
    async getSubscription() {
      await marketplaceApi.getCurrentUserSubscription(this.subscriptionId)
        .then(res => {
          if (res.data?.isCancelled) {
            this.$snotify.error(t('Subscription has been cancelled'));
            this.$router.push({name: 'marketplace-account-subscriptions', query: {status: 'cancelled'}});
            return;
          }

          this.loading = false;
          this.subscription = res.data;
        })
        .catch(async e => {
          handleApiErrors(e, this, 'Error retrieving subscription details');
          await this.$router.push({name: 'marketplace-account-subscription'});
        });
    }
  }
};
</script>
